import { Level } from '@chew/common/domains';
import { api } from '@chew/common/services/network/api';

export const getLevels = () => api.get<{ content: Level[] }>(`/v1/levels`).then((r) => r.content);
